import styled from "styled-components";


export const ModalTitle = styled.div`
    font-weight: 700;
    font-size: 20px;
`

export const ModalTitleBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
`
